import {
  Heart,
  ArrowLeft,
  Search,
  Send,
  Phone,
  Video,
  MoreVertical,
  Smile,
  Paperclip,
  Image,
  CheckCheck,
  Star,
  Clock,
  UserCheck,
  Users,
  MessageCircle,
  CircleCheck,
  CircleX,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "./ui/card";
import { Input } from "./ui/input";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { Badge } from "./ui/badge";
import { ScrollArea } from "./ui/scroll-area";
import React, { useState, useEffect, useRef } from "react";
import { Menu, X, User, Crown, Shield } from "lucide-react";
import { Button } from "./ui/button";
import { Helmet } from "react-helmet";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { useDispatch, useSelector } from "react-redux";
import { clearUserState } from "../redux/userSlice";
import {
  getWithoutTokenAPI,
  getWithTokenAPI,
  postWithTokenAPI,
} from "../util/Api";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import { Header } from "./Header";
import { setCurrentPage } from "../redux/navigationSlice.js";
import { useTranslation } from "react-i18next";
import { setProfileCount } from "../redux/profileCountSlice.js";
import { setMessageCount } from "../redux/messageCountSlice.js";

export function MessagesPage({ onNavigate }) {
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [conversationMessages, setConversationMessages] = useState([]);
  const [messageInput, setMessageInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [conversationlist, setConversationList] = useState([]);
  const [subpack, setSubsPack] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);
  const [ShowSubscribeDialog, setShowSubscribeDialog] = useState(false);
  const messagesEndRef = useRef(null);
  const navigate = useNavigate();
  const capitalize = (str) => {
    if (typeof str !== "string" || !str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const data = useSelector((state) => state.user);
  const token = data?.userId?.accessToken;
  const id = data?.userId?.user?._id;
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const [header, setHeader] = useState(null);
  const [profileData, setprofileData] = useState("");
  const [completion, setCompletion] = useState(0);

  const [reload, setReload] = useState(1);
  //-----------fetch all forcompletion bar
  // useEffect(() => {
  //   const fetchAllDetails = async () => {
  //     const response = await getWithTokenAPI(token, `/profile/get_all/${id}`);
  //     if (!response?.data) return;

  //     const { basicProfile, professionalProfile, preference, zodiac } =
  //       response.data;

  //     let completion = 0;

  //     if (basicProfile) completion = 1;
  //     if (professionalProfile) completion = 2;
  //     if (preference) completion = 3;

  //     // ✅ Check if all rasi houses are filled (not empty arrays)
  //     if (zodiac && zodiac.rasi) {
  //       const allHouses = Object.values(zodiac.rasi);
  //       const hasData = allHouses.some((house) => house && house.length > 0);

  //       if (hasData) {
  //         completion = 4;
  //       }
  //     }

  //     setCompletion(completion);
  //   };

  //   fetchAllDetails();
  // }, [token, id]);

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    scrollToBottom();
  }, [conversationMessages]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleLogout = () => {
    setShowLogoutDialog(true);
  };

  // useEffect(() => {
  //   const fetchHeader = async () => {
  //     try {
  //       const response = await getWithoutTokenAPI(`/header/get_all`);
  //       if (response?.data?.length) {
  //         const headerData = response.data[0];
  //         const fixedHeader = {
  //           ...headerData,
  //           logo: headerData.logo.replace(
  //             "s3.eu-north-1.amazonaws.com",
  //             "s3.ap-south-1.amazonaws.com"
  //           ),
  //         };
  //         setHeader(fixedHeader);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching header:", error);
  //     }
  //   };
  //   fetchHeader();
  // }, []);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/user-id/get_by_id?user_id=${id}`
        );
        setprofileData(response?.data?.profile?.name);
        setSubsPack(response?.data?.subscription?.plan_name);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };
    if (id && token) {
      fetchProfile();
    }
  }, [id, token]);

  const filteredConversations = (conversationlist || []).filter((conv) =>
    conv?.sender_id?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const selectedConv = conversationlist.find(
    (conv) => conv.sender_id?.user_id === selectedConversation
  );

  // Enhanced send message with better UX
  const handleSendMessage = async () => {
    if (!messageInput.trim()) {
      toast.error(`${t("Please enter a message")}`);
      return;
    }

    if (!id) {
      toast.error(`${t("Unable to send message: User not identified")}`);
      return;
    }

    if (!selectedConversation) {
      toast.error(`${t("Please select a conversation to send message")}`);
      return;
    }

    setIsSending(true);
    try {
      const payload = {
        sender_id: id,
        receiver_id: selectedConversation,
        content: messageInput,
      };

      // Optimistic update - create message with correct structure to show on RIGHT side
      const tempMessageId = Date.now().toString();
      const optimisticMessage = {
        _id: tempMessageId,
        sender: { user_id: id }, // Use 'sender' object with 'user_id' to match your API structure
        content: messageInput,
        createdAt: new Date().toISOString(),
        type: "text",
        is_read: false,
      };

      // Add optimistic message immediately (will show on right side)
      setConversationMessages((prev) => [...prev, optimisticMessage]);
      setMessageInput("");

      const response = await postWithTokenAPI(token, "/message/send", payload);

      // Replace optimistic message with actual response data when it comes
      if (response?.data) {
        setReload(1);
        // setConversationMessages((prev) =>
        //   prev.map((msg) =>
        //     msg._id === tempMessageId
        //       ? { ...response.data, _id: response.data._id || tempMessageId }
        //       : msg
        //   )
        // );
        dispatch(
          setMessageCount(response?.data?.unique_profiles_messaged_today)
        );
      }
      if (response?.statusCode == 403) {
        setShowSubscribeDialog(true);
      }

      // Update conversation list to show latest message
      setConversationList((prev) =>
        prev.map((conv) =>
          conv.sender_id.user_id === selectedConversation
            ? {
                ...conv,
                content: messageInput,
                createdAt: new Date().toISOString(),
              }
            : conv
        )
      );
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error(`${t("Failed to send message. Please try again.")}`);

      // Remove optimistic message if send failed
      setConversationMessages((prev) =>
        prev.filter((msg) => !msg._id.includes("temp"))
      );
    } finally {
      setIsSending(false);
    }
  };

  // Enhanced time formatting
  function timeAgo(dateString) {
    if (!dateString) return "Just now";

    const date = new Date(dateString);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);

    if (seconds < 60) return "Just now";
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
    if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;

    return date.toLocaleDateString();
  }

  const formatMessageTime = (dateString) => {
    if (!dateString) return "Just now";

    const date = new Date(dateString);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    const isYesterday =
      new Date(now.setDate(now.getDate() - 1)).toDateString() ===
      date.toDateString();

    if (isToday) {
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    } else if (isYesterday) {
      return "Yesterday";
    } else {
      return date.toLocaleDateString([], { month: "short", day: "numeric" });
    }
  };

  // Enhanced conversation list fetch
  useEffect(() => {
    const fetchmessagedlist = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/message/inbox?user_id=${id}`
        );
        if (response) {
          const conversations = Array.isArray(response?.data?.data)
            ? response.data.data
            : [];
          setConversationList(conversations);
          if (conversations.length > 0 && !selectedConversation) {
            // Auto-select first conversation
            setSelectedConversation(conversations[0].sender_id.user_id);
          }
        }
      } catch (error) {
        console.error("Error fetching conversations:", error);
        toast.error(`${t("Failed to load conversations")}`);
      }
    };
    if (token && id) {
      fetchmessagedlist();
    }
  }, [token, id]);

  // Enhanced messages fetch
  useEffect(() => {
    const fetchmessageslist = async () => {
      if (!selectedConversation || !id || !token) return;

      setIsLoadingMessages(true);
      try {
        const response = await getWithTokenAPI(
          token,
          `/message/get_all?user1=${id}&user2=${selectedConversation}`
        );
        if (response.statusCode == 200) {
          setConversationMessages(response?.data?.data || []);
        }
      } catch (error) {
        console.error("Error fetching messages:", error);
        toast.error(`${t("Failed to load messages")}`);
      } finally {
        setIsLoadingMessages(false);
      }
    };
    fetchmessageslist();
  }, [selectedConversation, token, id, reload]);

  // Handle Enter key for sending messages
  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Toaster position="top-right" />
      <Header />

      <Helmet>
        <title>Avan Aval - Messages</title>
        <meta name="description" content="This is my page description." />
        <meta name="keywords" content="React, Helmet, SEO" />
      </Helmet>
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 h-[500px]">
          {/* Conversations List */}
          <div className="lg:col-span-1" style={{ height: "620px" }}>
            {" "}
            {/* 80% of 500px */}
            <Card className="h-full">
              <CardContent
                className="p-0 h-full flex flex-col"
                style={{ backgroundColor: "rgba(200, 197, 197, 0.17)" }}
              >
                <div className="p-4  border-border">
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-xl font-semibold">{t("Messages")}</h2>
                    <Badge
                      variant="secondary"
                      className="bg-blue-100 text-blue-700"
                    >
                      <Users className="w-3 h-3 mr-1" />
                      {conversationlist.length} {t("chats")}
                    </Badge>
                  </div>
                  <div className="relative" style={{ display: "flex" }}>
                    <Search
                      className="w-5 h-5 mt-1 mr-1"
                      style={{
                        position: "relative",
                        top: "3",
                        bottom: "5",
                        textAlign: "center",
                      }}
                    />
                    <Input
                      placeholder={t("Search conversations...")}
                      className="pl-10"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{
                        backgroundColor: "white",
                      }}
                    />
                  </div>
                </div>

                <ScrollArea className="h-full overflow-y-auto scrollbar-hide " style={{  msOverflowStyle: "none",
  scrollbarWidth: "none",}}>
                  <div className="h-full">
                    {filteredConversations.length === 0 ? (
                      <div className="flex flex-col items-center justify-center h-full min-h-[200px] text-center p-8">
                        <MessageCircle className="h-12 w-12 text-muted-foreground mb-4 mt-4" />
                        <h3 className="text-lg font-semibold mb-2">
                          {t("No conversations")}
                        </h3>
                        <p className="text-muted-foreground text-sm">
                          {searchQuery
                            ? `${t("No matches found")}`
                            : `${t(
                                "Start a conversation by exploring profiles"
                              )}`}
                        </p>
                        {!searchQuery && (
                          <Button
                            onClick={() => navigate("/browse")}
                            className="mt-4 bg-gradient-to-br from-red-500 to-pink-600 text-white cursor-pointer"
                            variant="outline"
                          >
                            {t("Explore Profiles")}
                          </Button>
                        )}
                      </div>
                    ) : (
                      <div className="space-y-1 p-2">
                        {filteredConversations.map((conversation) => (
                          <div
                            key={conversation._id}
                            onClick={() =>
                              setSelectedConversation(
                                conversation.sender_id.user_id
                              )
                            }
                            className={`p-3 rounded-lg cursor-pointer bg-white transition-all duration-200 border mb-4  ${
                              selectedConversation ===
                              conversation.sender_id.user_id
                                ? "border-black-600"
                                : "border-gray-200"
                            }`}
                            style={{ borderLeft: "5px solid red" }}
                          >
                            <div className="flex items-center space-x-3">
                              <div
                                className="relative cursor-pointer"
                                onClick={async () => {
                                  try {
                                    const profileId =
                                      conversation.sender_id.user_id;
                                    const profilename =
                                      conversation.sender_id.name;
                                    const payload = {
                                      viewer_id: id,
                                      viewed_id: profileId,
                                    };
                                    const response = await postWithTokenAPI(
                                      token,
                                      `/profile-view/track`,
                                      payload
                                    );
                                    if (response?.statusCode === 200) {
                                      navigate(`/view-profile/${profilename}`, {
                                        state: { profileId: profileId },
                                      });
                                      dispatch(
                                        setProfileCount(
                                          response?.data
                                            ?.unique_profiles_viewed_today
                                        )
                                      );
                                    } else {
                                      console.error("Error in viewing profile");
                                    }
                                  } catch (error) {
                                    console.error(
                                      "Error in viewed profile post"
                                    );
                                  }
                                }}
                              >
                                <Avatar className="w-16 h-16 border ring-2 ring-offset-2 ring-muted">
                                  <AvatarImage
                                    src={conversation?.sender_id?.profileImage}
                                    className="object-cover"
                                  />
                                  <AvatarFallback className="bg-gradient-to-br from-blue-100 to-purple-100">
                                    {conversation?.sender_id?.name
                                      ?.split(" ")
                                      .map((n) => n[0])
                                      .join("")}
                                  </AvatarFallback>
                                </Avatar>
                                {/* <div
                                  className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-grey ${
                                    conversation?.is_read
                                      ? "bg-green-500"
                                      : "bg-gray-400"
                                  }`}
                                ></div> */}
                              </div>

                              <div
                                className="flex-1 min-w-0"
                                style={{
                                  borderRadius: "25px",
                                  padding: "1vh",
                                  boxShadow: "0px 0px  1px silver",
                                }}
                              >
                                <div className="flex items-end justify-between gap-2">
                                  <div className="flex-1 min-w-0">
                                    <h3 className="text-md font-semibold text-gray-900 truncate flex items-center gap-1">
                                      {capitalize(
                                        conversation?.sender_id?.name
                                      )}
                                      {conversation.sender_id?.isVerified && (
                                        <Badge
                                          variant="outline"
                                          className="h-4 px-1 text-xs bg-green-50 text-green-700 border-green-200"
                                        >
                                          <UserCheck className="w-3 h-3" />
                                        </Badge>
                                      )}
                                    </h3>
                                    <p className="text-sm text-gray-600 truncate mt-1 line-clamp-1">
                                      {capitalize(conversation?.content)}
                                    </p>
                                  </div>
                                  <div className="flex items-center gap-2 flex-shrink-0">
                                    {conversation?.is_read ? (
                                      <CheckCheck className="w-5 h-5 text-blue-600" />
                                    ) : (
                                      <CheckCheck className="w-5 h-5 text-muted-foreground" />
                                    )}
                                    <span className="text-xs text-gray-500 whitespace-nowrap">
                                      {conversation?.createdAt
                                        ? timeAgo(conversation.createdAt)
                                        : ""}
                                    </span>
                                  </div>
                                </div>
                                {/* <div className="flex items-center justify-between mt-2">
                                  <span className="text-xs text-muted-foreground flex align-center  gap-1">
                                     <div
                                  className="w-2 h-2 mt-1 rounded-full border-2 border-grey bg-green-500"
                                />
                                    {conversation?.lastSeen ||
                                      "Offline"}
                                  </span>
                                  {conversation?.unreadCount && (
                                    <Badge
                                      variant="destructive"
                                      className="h-5 px-1.5 text-xs"
                                    >
                                      {conversation.unreadCount}
                                    </Badge>
                                  )}
                                </div> */}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </ScrollArea>
              </CardContent>
            </Card>
          </div>

          {/* Chat Area */}
          <div className="lg:col-span-2" style={{ height: "620px" }}>
            {selectedConv ? (
              <Card className="h-full">
                <CardContent className="p-0 h-full flex flex-col">
                  {/* Chat Header */}
                  <div className="p-4 border-b border-border bg-gradient-to-r from-gray-50 to-white">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <div
                          className="relative cursor-pointer"
                          onClick={async () => {
                            try {
                              const profileId = selectedConv.sender_id.user_id;
                              const profilename = selectedConv.sender_id.name;
                              navigate(`/view-profile/${profilename}`, {
                                state: { profileId: profileId },
                              });
                            } catch (error) {
                              console.error("Error in viewed profile post");
                            }
                          }}
                        >
                          <Avatar className="w-24 h-24 ring-2 border ring-offset-2 ring-blue-100">
                            <AvatarImage
                              src={selectedConv?.sender_id?.profileImage}
                              className="object-cover"
                            />
                            <AvatarFallback className="bg-gradient-to-br from-blue-100 to-purple-100">
                              {selectedConv?.sender_id?.name
                                ?.split(" ")
                                .map((n) => n[0])
                                .join("")}
                            </AvatarFallback>
                          </Avatar>
                          <div
                            className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-white ${
                              selectedConv?.isOnline
                                ? "bg-green-500"
                                : "bg-gray-400"
                            }`}
                          ></div>
                        </div>
                        <div className="flex-cols justify-around gap-0">
                          <div className="flex items-center gap-2">
                            <h3 className="text-3xl font-bold text-gray-900">
                              {capitalize(selectedConv?.sender_id?.name)}
                            </h3>
                            {selectedConv.sender_id?.isVerified && (
                              <Badge
                                variant="outline"
                                className="bg-green-50 text-green-700 border-green-200"
                              >
                                <UserCheck className="w-3 h-3 mr-1" />
                                {t("Verified")}
                              </Badge>
                            )}
                          </div>
                          {/* <p className="text-sm text-muted-foreground flex items-center gap-1">
                            <span>
                              {selectedConv?.sender_id?.mobile_number}
                            </span>
                          </p> */}
                          {/* <Clock className="w-3 h-3 mb-1 text-red-500"/> */}
                          <div className="flex items-center gap-1">
                            {selectedConv?.isOnline ? (
                              <CircleCheck className="w-3 h-3 text-green-400" />
                            ) : (
                              <CircleX className="w-3 h-3 text-red-400" />
                            )}
                            <span className="text-xs text-muted-foreground">
                              {selectedConv?.isOnline
                                ? "Online"
                                : selectedConv?.lastSeen || "Offline"}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* <div className="flex items-center space-x-2">
                        <Button
                          size="icon"
                          variant="ghost"
                          className="rounded-full"
                        >
                          <Phone className="h-5 w-5" />
                        </Button>
                        <Button
                          size="icon"
                          variant="ghost"
                          className="rounded-full"
                        >
                          <Video className="h-5 w-5" />
                        </Button>
                        <Button
                          size="icon"
                          variant="ghost"
                          className="rounded-full"
                        >
                          <MoreVertical className="h-5 w-5" />
                        </Button>
                      </div> */}
                    </div>
                  </div>

                  {/* Messages */}
                  <ScrollArea className="flex-1 p-4 bg-gradient-to-b from-white to-gray-50/50 overflow-y-auto">
                    {isLoadingMessages ? (
                      <div className="flex items-center justify-center h-32">
                        <div className="flex items-center gap-2 text-muted-foreground">
                          <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
                          {t("Loading messages...")}
                        </div>
                      </div>
                    ) : conversationMessages.length < 2 ? (
                      <div className="flex flex-col items-center justify-center h-64 text-center">
                        <MessageCircle className="h-16 w-16 text-blue-600 mb-4" />
                        <h3 className="text-lg font-semibold mb-2">
                          {t("No messages yet")}
                        </h3>
                        <p className="text-muted-foreground text-sm mb-4">
                          {t("Start the conversation by sending a message")}
                        </p>
                        <div className="flex gap-2">
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => setMessageInput("Hello! 👋")}
                          >
                            {t("Say Hello")}
                          </Button>
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => setMessageInput("Hi there! 😊")}
                          >
                            {t("Send Hi")}
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div className="space-y-4">
                        {conversationMessages.map((message, index) => (
                          <div
                            key={message._id || index}
                            className={`flex ${
                              message?.sender?.user_id === id ||
                              message?.sender_id === id
                                ? "justify-end"
                                : "justify-start"
                            }`}
                          >
                            {message?.content !== "" && (
                              <div className="flex items-end gap-2 max-w-[70%]">
                                <div
                                  className={`px-3 py-1 rounded-2xl shadow-sm ${
                                    message?.sender?.user_id === id ||
                                    message?.sender_id === id
                                      ? "bg-gradient-to-br from-red-500 to-pink-600 text-white"
                                      : "bg-white border border-gray-200 rounded-bl-none"
                                  }`}
                                >
                                  <p className="text-md leading-relaxed">
                                    {message?.content}
                                  </p>
                                  <div className="flex items-center justify-end mt-1">
                                    <span
                                      className={`text-xs ${
                                        message?.sender?.user_id === id
                                          ? "text-red-100"
                                          : "text-muted-foreground"
                                      }`}
                                    >
                                      {formatMessageTime(message?.createdAt)}
                                    </span>
                                    {message?.sender?.user_id === id &&
                                      (message?.is_read ? (
                                        <CheckCheck className="w-3 h-3 text-red-200" />
                                      ) : (
                                        <CheckCheck className="w-3 h-3 text-red-300" />
                                      ))}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                        <div ref={messagesEndRef} />
                      </div>
                    )}
                  </ScrollArea>

                  {/* Message Input */}
                  <div className="p-4 border-t border-border bg-white">
                    <div className="flex items-center space-x-2">
                      {/* <Button size="sm" variant="ghost">
                        <Paperclip className="h-4 w-4" />
                      </Button>
                      <Button size="sm" variant="ghost">
                        <Image className="h-4 w-4" />
                      </Button> */}
                      <div className="flex-1 relative">
                        <Input
                          placeholder={t("Type a message...")}
                          value={messageInput}
                          onChange={(e) => setMessageInput(e.target.value)}
                          onKeyPress={handleKeyPress}
                          className="pr-20"
                          disabled={isSending}
                        />
                        {/* <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center space-x-1">
                          <Button size="sm" variant="ghost">
                            <Smile className="h-4 w-4" />
                          </Button>
                        </div> */}
                      </div>
                      <Button
                        size="sm"
                        onClick={handleSendMessage}
                        disabled={!messageInput.trim() || isSending}
                        className="bg-gradient-to-br from-red-500 to-pink-600 text-white"
                      >
                        {isSending ? (
                          <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin cursor-pointer" />
                        ) : (
                          <Send className="h-4 w-4" />
                        )}
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ) : (
              <Card className="h-full">
                <CardContent className="h-full flex flex-col items-center justify-center p-8">
                  <div className="text-center max-w-md">
                    <div className="w-20 h-20 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                      <MessageCircle className="h-10 w-10 text-blue-500" />
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">
                      {t("Welcome to Messages")}
                    </h3>
                    <p className="text-muted-foreground mb-6 leading-relaxed">
                      {t(
                        "Select a conversation from the list to start messaging, or explore new profiles to find your perfect match."
                      )}
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 justify-center">
                      <Button
                        onClick={() => navigate("/browse")}
                        className="bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 cursor-pointer"
                      >
                        <Search className="w-4 h-4 mr-2" />
                        {t("Explore Profiles")}
                      </Button>
                      <Button
                        variant="outline"
                        className="cursor-pointer"
                        onClick={() => navigate("/matches")}
                      >
                        <Users className="w-4 h-4 mr-2" />
                        {t("View Matches")}
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            )}
          </div>
        </div>
      </div>
      <AlertDialog
        open={ShowSubscribeDialog}
        onOpenChange={setShowSubscribeDialog}
      >
        <AlertDialogContent className="max-w-sm text-center">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-red-600 text-xl font-semibold">
              🔔 {t("Subscription Required")}
            </AlertDialogTitle>
            <AlertDialogDescription className="text-gray-600 mt-2">
              {t("Upgrade your plan to explore more matches")}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <div className="flex justify-center gap-3 mt-4">
            <AlertDialogCancel
              onClick={() => setShowSubscribeDialog(false)}
              className="cursor-pointer border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-lg"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
              onClick={() => {
                setShowSubscribeDialog(false);
                dispatch(setCurrentPage("subscription"));
              }}
            >
              {t("Subscribe Now")}
            </AlertDialogAction>
          </div>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
